export default function getAppName() {
  if (!window.hubspot ||
  // @ts-expect-error - No bender type in the hubspot window object yet
  !window.hubspot.bender ||
  // @ts-expect-error - No bender type in the hubspot window object yet
  !window.hubspot.bender.currentProject) {
    return null;
  }

  // @ts-expect-error - No bender type in the hubspot window object yet
  return window.hubspot.bender.currentProject;
}